<template>
	<div id="page-content">
				<div class="about-item about-history">
					<div class="about-item-info col-md-6 col-xs-12">
						<h1>Company History</h1>
						<p>
						Established in 1987, Mutual Success Lighting Fixture Inc., has maintained its position as a quality lighting provider in the industry.
						<br/><br/>
						With its over twenty-five (25) years of continuous innovation, customer service and excellence, the company relatively expanded, numerically evident by the availability of product lines in more than 200 major depots and DIY's nationwide.
						<br/><br/>
						It is the commitment to exceeding the needs of the household and construction industry that makes the company go further. The company ensures that its importation will give customers a wide array of lighting designs and functionalities at reasonable cost. As an observance to quality standards, the products are CE, ICC and DTI certified.
						<br/><br/>
						Mutual Success Lighting Fixture Inc. offers all types of lighting requirements. From ambient lighting to general lighting, from accent and task lighting to outdoor and industrial lighting; all of which have the objective of providing lighting needs and satisfaction essential to daily living.
						</p>
					</div>
					<div style="clear: both"></div>
					<div class="about-item-info col-md-6 col-xs-12 pull-right">
						<h1>Vision</h1>
						<p>
						To be a major player in the industry recognized for its pursuits of sustainability and principle.
						</p>
					</div>
					<div style="clear: both"></div>
					<div class="about-item-info col-md-6 col-xs-12">
						<h1>Mission</h1>
						<p>
						To be a one-stop quality lighting provider for the household and construction industry and go beyond customers' expectations through commitment to operational excellence, performance, innovation; customer-centrism and integrity.
						</p>
					</div>
				</div>
				
				<div style="padding: 3em;">
					<h1 style="text-align: center; padding: 2em;">Our Business Partners</h1>
					<div class=" col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2"><!-- parent -->

						
						<div class="col-xs-6 col-sm-4 col-md-3 bp" v-for="(bp, index) in bps" :key="index">
							<img  :src="'static/images/mybp/' + bp.img" :alt="bp.img"/>
							<div class="bpc col-xs-12">
								<img :src="'static/images/bp/' + bp.img" :alt="bp.img"/>
							</div>
						</div>
						
					</div>
				</div>
				
				<div class="cta-section-2">
					<router-link to="/products">Check out our products!</router-link>
				</div>
	</div>
</template>

<script>

	export default{
		data(){
			return {
				bps: [
					{
						img: '1.jpg'
					},
					{
						img: '2.jpg'
					},
					{
						img: '3.jpg'
					},
					{
						img: '4.jpg'
					},
					{
						img: '5.jpg'
					},
					{
						img: '6.jpg'
					},
					{
						img: '7.jpg'
					},
					{
						img: '8.jpg'
					},
					{
						img: '9.jpg'
					},
					{
						img: '10.jpg'
					},
					{
						img: '11.jpg'
					},
					{
						img: '12.jpg'
					}
				]
			}
		},
		methods: {
			AboutResponsive: function(self){
				var bp = $('.bp');
				var bpParent = bp[0].parentNode;
				$(bpParent).children(".clearboth").remove();
				var ww = $(window).outerWidth();

				if(ww >= 992){
					for(var i = 0; i < bp.length; i++){
						if(i % 4 === 0){
							var node = document.createElement("div");
							node.setAttribute("class", "clearboth")
							bpParent.insertBefore(node, bp[i]);
						}
					}
				}
				
				else if(ww >= 768 && ww < 992){
					for(var i = 0; i < bp.length; i++){
						if(i % 3 === 0){
							var node = document.createElement("div");
							node.setAttribute("class", "clearboth")
							bpParent.insertBefore(node, bp[i]);
						}
					}
				}

				else if(ww < 768){
					for(var i = 0; i < bp.length; i++){
						if(i % 2 === 0){
							var node = document.createElement("div");
							node.setAttribute("class", "clearboth")
							bpParent.insertBefore(node, bp[i]);
						}
					}
				}
				
			}
		},
		mounted(){
			var self = this;
			// relativeTo
			relativeTo('nav', this.$el);
			
			this.AboutResponsive(self);
			$(window).on("resize.About", function(e){
				self.AboutResponsive(self);
			});

		},
		destroyed(){
			$(window).off("resize.About");
		}
	}
</script>


// WEBPACK FOOTER //
// About.vue?27781ffe